<template>
  <div class="body-container">
      <div class="flex-wrap text-center text-box p-3">
        <span class="text-content">Unfortunately we encountered an error, please wait a moment and click retry below.</span>
      </div>
      <div class="d-flex justify-content-center">
        <button class="retry-button" @click="onRetryClicked">Retry</button>
      </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import { environmentConfig } from "@/config/environmentConfig";

export default {
  name: 'ErrorPage',
  computed: {
    ...mapState(['acquisitionConfig']),
  },
  methods: {
    onRetryClicked() {
      window.open(`${environmentConfig.zedGamesHEHost}`, '_self');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
